<!-- <div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div> -->
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <div class="row">
        <div class="col-md-5 col-12">
            <div [hidden]="!includeLabel">
                <label for="input-list">{{inputSpan? inputSpan: 'Itens disponíveis:'}}</label>
            </div>
            <select class="lista" class="form-control lista" name="input-list" multiple
                [disabled]="!this.itens || this.itens.length == 0" (input)="selecionarItensInput($event)">
                <option *ngFor="let item of itens" value="{{idPropriedade && item? item[idPropriedade]: item}}">
                    <span>{{nomePropriedade && item? item[nomePropriedade]: item}}</span>
                </option>
            </select>
            <app-input-feedback [hidden]="validSizeInput()"
                [feedbackMessage]="'Nenhum item encontrado'"></app-input-feedback>
        </div>
        <div class="col">
            <div class="row mt-3">
                <button type="button" class="btn btn-success mx-1 mb-2 mt-1" (click)="vincularItens()"
                    [disabled]="!this.inputSelecionados || this.inputSelecionados.length == 0">
                    <i class="fa fa-chevron-right mx-2"></i>
                </button>
                <button type="button" class="btn btn-success mx-1 mb-2" (click)="desvincularItens()"
                    [disabled]="!this.outputSelecionados || this.outputSelecionados.length == 0">
                    <i class="fa fa-chevron-left mx-2"></i>
                </button>
                <button type="button" class="btn btn-success mx-1 mb-2" (click)="editarItens()"
                    [disabled]="this.mostrarEdit && (!this.outputSelecionados || this.outputSelecionados.length == 0)">
                    <i class="fa fa-edit mx-2"></i>
                </button>
            </div>
        </div>
        <div class="col-md-5 col-12 ms-3">
            <div [hidden]="!includeLabel">
                <label for="output-list">{{outputSpan? outputSpan: 'Itens vinculados:'}}</label>
            </div>
            <select [name]="name" class="form-control lista" name="output-list" multiple
                [disabled]="!this.itensVinculados || this.itensVinculados.length == 0"
                (input)="selecionarItensOutput($event)">
                <option *ngFor="let item of itensVinculados"
                    value="{{idPropriedade && item? item[idPropriedade]: item}}">
                    <span>{{nomePropriedade && item? item[nomePropriedade]: item}}</span>
                    <!-- <input *ngIf="campoAdicional" type="{{campoAdicional}}" (input)="item[nomeCampoAdicional]= $event"> -->
                </option>
            </select>
        </div>
        <div class="col" *ngIf="mostrarOrdenacao">
            <div class="row mt-3">
                <button type="button" class="btn btn-success mx-1 mb-2 mt-1" (click)="moverItensAcima()"
                    [disabled]="(!this.outputSelecionados || this.outputSelecionados.length == 0)|| !habilitarMoverItensAcima()">
                    <i class="fa fa-chevron-up mx-2"></i>
                </button>
                <button type="button" class="btn btn-success mx-1 mb-2" (click)="moverItensAbaixo()"
                    [disabled]="(!this.outputSelecionados || this.outputSelecionados.length == 0)|| !habilitarMoverItensAbaixo()">
                    <i class="fa fa-chevron-down mx-2"></i>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #showSpan>
    <div class="row detail-list">
        <div class="col-md-5 col-12">
            <div [hidden]="!includeLabel">
                <label for="output-list">{{outputSpan? outputSpan: 'Itens vinculados:'}}</label>
            </div>
            <div *ngFor="let item of itensVinculados">
                <p>{{nomePropriedade? item[nomePropriedade]: item}}</p>
                <hr>
            </div>
        </div>
    </div>
</ng-template>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validMaxSize()" [feedbackMessage]="spanMaxSize"></app-input-feedback>
    <app-input-feedback [hidden]="!validMinSize()" [feedbackMessage]="spanMinSize"></app-input-feedback>
    <app-input-feedback [hidden]="validSizeOutput() || minSize!=1"
        [feedbackMessage]="'Pelo menos um item deve ser cadastrado'"></app-input-feedback>
</div>
